/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * Menu item. Hover is a visible tint; the selected item is blue on light blue
 * so the current value of a Select can be told apart from the hovered one.
 */

import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";
import typography from "assets/theme/base/typography";
import pxToRem from "assets/theme/functions/pxToRem";

const { brand, text, surface } = colors;
const { borderRadius } = borders;
const { size } = typography;

const menuItem = {
  styleOverrides: {
    root: {
      minHeight: pxToRem(36),
      padding: `${pxToRem(8)} ${pxToRem(12)}`,
      borderRadius: borderRadius.sm,
      fontSize: size.sm,
      fontWeight: 400,
      color: text.main,
      gap: pxToRem(8),
      transition: "background-color 120ms ease, color 120ms ease",
      "&:hover": {
        backgroundColor: surface.container,
        color: text.main,
      },
      "&.Mui-focusVisible": {
        backgroundColor: surface.container,
        boxShadow: `inset 0 0 0 1px ${brand.primary}`,
      },
      "&.Mui-selected, &.Mui-selected:hover, &.Mui-selected.Mui-focusVisible": {
        backgroundColor: brand.primaryContainer,
        color: brand.primary,
        fontWeight: 600,
      },
      "& + .MuiMenuItem-root": {
        marginTop: pxToRem(2),
      },
      "& .MuiListItemIcon-root": {
        minWidth: 0,
        color: "inherit",
      },
    },
  },
};

export default menuItem;
